import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

const Footer = () => {
  return (
    <div className="main-div">
      <div className="container-fluid">
        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-3 pt-3 footer-content">
          <div className="col">
            <div className="img-left">
              <img
                width="155px"
                src={require("../assets/images/logo/jpp-logo.png")}
              />
            </div>
            <div className=" text-white footer-text">
              <p>
                Justice Project Pakistan (JPP) is a legal action non-profit that
                provides pro-bono legal representation to the most vulnerable
                Pakistani prisoners facing the hardest punishments. Our clients
                include those facing the death penalty, the mentally ill and
                victims of police torture. In December 2016, JPP's Executive
                Director was presented the National Human Rights Award by the
                President of Pakistan.
              </p>
            </div>
            <div className="row row-cols-1 row-cols-md-2">
              <div
                className="col-md-6"
                style={{ display: "flex", alignItems: "center" }}
              >
                <p style={{ fontSize: "38px" }} className="font-mb">
                  Follow Us:
                </p>
              </div>
              <div className="col">
                <div className=" footer-links ">
                  {/* <div className="d-flex"> */}
                  <p style={{ marginLeft: "10px" }}>
                    <a href="https://jpp.org.pk/">www.jpp.org.pk</a>
                  </p>
                  {/* </div> */}
                  <div
                    style={{
                      display: "flex",
                      // marginLeft: "118px",
                      gap: "10px",
                    }}
                  >
                    <a
                      className="link-light"
                      href="https://www.facebook.com/JusticeProjectPakistan/"
                    >
                      {/* <li className="ms-3" data-aos="zoom-in"> */}
                      <FacebookIcon
                        className="social-icon-facebook"
                        style={{ fontSize: "30" }}
                      />
                      {/* </li> */}
                    </a>
                    <a
                      className="link-light"
                      href="https://www.instagram.com/justiceprojectpak/?hl=en"
                    >
                      {/* <li className="ms-3" data-aos="zoom-in"> */}
                      <InstagramIcon
                        className="social-icon-instagram"
                        style={{ fontSize: "30" }}
                      />
                      {/* </li> */}
                    </a>
                    <a
                      className="link-light"
                      href="https://twitter.com/justiceproject_?lang=en"
                    >
                      {/* <li className="ms-3" data-aos="zoom-in"> */}
                      <TwitterIcon
                        className="social-icon-twitter"
                        style={{ fontSize: "30" }}
                      />
                      {/* </li> */}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col mt-3">
            <p style={{ fontSize: "41px", textAlign: "center" }}>Information</p>
            <hr style={{ marginLeft: "107px", width: "50%" }} />
            <br />
            <div className="row row-cols-2">
              <div className="col">
                <p>Publisher</p>
                <p>Book Writer</p>

                <p style={{ marginTop: "31px" }}>Book Editors</p>
                <p style={{ marginTop: "61px" }}>Website Editors</p>
                <p style={{ marginTop: "29px" }}>Illustrator</p>
              </div>
              <div className="col">
                <p>Justice Project Pakistan</p>
                <p>Radha Shah, in collaboration with JPP</p>
                {/* <p></p> */}
                <p>
                  Sarah Belal, Aurangzaib Khan, Ali Haider Habib,
                  <br />
                  Zarnaab Janjua, in collaboration with JPP
                </p>
                {/* <p></p>
            <p></p>
            <p></p> */}
                <p>Jahanzeb Hussain, Mahnoor Bari</p>
                <p>Marium Ali</p>
              </div>
            </div>
            {/* </div> */}
            {/* <div className="col-lg-2 mt-3"> */}
          </div>
          {/* <div className="col">
            <p>Website Development</p>
            <p>Data Analysis</p>
            <p>Design and Layout</p>
          </div>
          <div className="col">
            <p>OptiWise Solutions</p>
            <p>Zille Huma</p>
            <p>Ema Anis</p>
          </div> */}
          <div className="col footer-links mt-3">
            <p style={{ fontSize: "40px" }}>Data Sources</p>
            <hr className="w-50" />
            <br />
            <p>Punjab Prisons Department, Sindh Prisons Department</p>
            {/* <p>Sindh Prisons Department </p> */}
            <p>KP Prisons Department, Balochistan Prisons Department </p>
            {/* <p>Balochistan Prisons Department </p> */}
            <p>Federal Ombudsman Reports 2018-2021 </p>
            <p href="https://www.interior.gov.pk">
              Ministry of Interior, Punjab Police Department{" "}
            </p>
            {/* <p>Punjab Police Department </p> */}
            <p>Cursor for Development and Education Pakistan (CODE) </p>
            <p>National Counter Terrorism Authority (NACTA) </p>
          </div>
        </div>

        <div className="container-sm">
          <hr style={{ color: "#C0C0C0", width: "100%", margin: "16px" }} />
        </div>
        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-3 footer-adds">
          <div className="col">
            <p>
              Website developed by{" "}
              <a
                style={{
                  color: "#f15d52",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
                target="blank"
                href="https://optiwisesolutions.com/"
              >
                OptiWise Solutions
              </a>
            </p>
          </div>
          <div className="col">
            <p>
              Data Analysis by{" "}
              <span
                style={{
                  color: "#f15d52",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                {" "}
                Zille Huma{" "}
              </span>
            </p>
          </div>
          <div className="col">
            <p>
              Design and Layout by{" "}
              <span
                style={{
                  color: "#f15d52",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                Ema Anis
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
